<template>
  <div class="relative w-full h-full" @click="$emit('dbclick')" @dblclick="$emit('dbclick')">
    <RollUpMetric
      v-if="metric?.value"
      :id="metricName + metric?.value"
      :metric="metric"
      :label="label"
      :is-editable="false"
      :hide-graph="true"
      :is-on-prospecting="true" />
    <MetricsTableForecast
      v-else-if="metric?.metricName == 'forecast_status'"
      :label="label"
      :is-editable="metric?.children ? metric?.children[metric?.children?.length - 1].hasOwnProperty('edit') : false"
      :kpi-name="label"
      :selected-range="selected_date_range"
      :object-type="getLayoutComponentProps(dataSource)?.component_props?.objectType"
      :current-forecast="current_forecast"
      :page-reference="PAGE_REFERENCES.FORECASTING"
      :metrics-table="metrics_table" />
    <div
      v-else
      class="relative flex overflow-hidden w-full h-full shadow-sm rounded-md"
      :class="[
        {
          'shadow-[#1037FF80]': metric?.input_type == 'Number',
          'shadow-[#9747FF80]': metric?.input_type == 'Decimal',
          'shadow-[#0D729980]': metric?.input_type == 'Percent',
          'shadow-[#45D72D80]': metric?.input_type == 'Currency',
          'shadow-[#D1970080]': metric?.input_type == 'StarRating',
          'shadow-[#DB00FF80]': metric?.input_type == 'BarRating'
        }
      ]">
      <BigKpi
        :is-editable="metric?.children ? metric?.children[metric?.children?.length - 1].hasOwnProperty('edit') : false"
        :kpi-name="label"
        :selected-range="selected_date_range"
        :symbol-post="metric?.children ? metric?.children[metric?.children?.length - 1]?.post_symbol : null"
        :symbol-pre="metric?.children ? metric?.children[metric?.children?.length - 1]?.pre_symbol : null"
        :is-mocked="true"
        :object-type="getLayoutComponentProps(dataSource)?.component_props?.objectType"
        :current-forecast="current_forecast"
        :page-reference="PAGE_REFERENCES.FORECASTING"
        :metric="metric"
        :metrics="metric?.children" />
      <div
        :class="[
          {
            'blue-bottom-shadow': metric?.input_type == 'Number',
            'purple-bottom-shadow': metric?.input_type == 'Decimal',
            'light-blue-bottom-shadow': metric?.input_type == 'Percent',
            'green-bottom-shadow': metric?.input_type == 'Currency',
            'yellow-bottom-shadow': metric?.input_type == 'StarRating',
            'pink-bottom-shadow': metric?.input_type == 'BarRating'
          }
        ]"
        class="absolute -bottom-[130px] overflow w-[100%] h-32 z-30 left-0" />
    </div>
  </div>
</template>

<script>
import BigKpi from "@/components/shared/BigKpi.vue"
import MetricsTableForecast from "@/components/shared/MetricsTableForecast.vue"
import { PAGE_REFERENCES } from "@/store/constants/references"
import RollUpMetric from "@/components/shared/rollup-metrics/RollUpMetric.vue"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { MetricsTableForecast, BigKpi, RollUpMetric },
  props: {
    currentTemplate: {
      type: Object,
      required: true
    },
    metricName: {
      type: String,
      required: true
    },

    dataSource: {
      type: String,
      default: null
    },

    label: {
      type: String,
      default: null
    }
  },
  emits: ["dbclick"],
  data() {
    return {
      PAGE_REFERENCES,
      metrics_table: [],
      metric: null,
      selected_date_range: null,
      current_forecast: null

      // metric_clone: null,
    }
  },
  computed: {
    // hasValues() {
    //   return this.metric_clone.history?.length > 0
    // }
  },

  created() {
    this.register_listeners()
  },
  activated() {
    this.register_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },

  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.REFRESH_FORECAST_METRIC, ({ metric, data_source = null }) => {
        if (Object.hasOwn(metric, "metricName")) {
          if (this.dataSource == data_source && this.metricName == metric.metricName) {
            this.metric = JSON.parse(JSON.stringify(metric))
          }
        }
      })
      this.$emitter.on(ALL_EMITTERS.REFRESH_FORECAST_TABLE_METRICS, ({ metrics }) => {
        this.metrics_table = metrics.filter(
          (m) =>
            m.metricName &&
            m.metricName != "arr" &&
            m.metricName != "mrr" &&
            m.metricName != "gap_to_grr" &&
            m.metricName != "gap_to_nrr" &&
            m.metricName != "gap_to_bookings" &&
            m.metricName != "forecast_summary"
        )
        this.metrics_table.map((metric) => {
          if (metric?.children && metric?.children[metric?.children?.length - 1]?.post_symbol) {
            metric["symbolPost"] = metric.children[metric.children.length - 1].post_symbol
          }
          if (metric?.children && metric?.children[metric?.children?.length - 1]?.pre_symbol) {
            metric["symbolPre"] = metric.children[metric.children.length - 1].pre_symbol
          }
        })
        this.metric = {
          metricName: "forecast_status"
        }
      })
    },
    unregister_listeners() {
      // this.$emitter.off(ALL_EMITTERS.REFRESH_FORECAST_METRIC)
    },
    getLayoutComponentProps(component_reference) {
      return this.currentTemplate.layout.find((l) => l.props.component_reference == component_reference)?.props
    }
  }
}
</script>

<style scoped>
.blue-bottom-shadow {
  border-radius: 100%;
  box-shadow: 0px -25px 28px -20px #1037ff80;
}

.purple-bottom-shadow {
  border-radius: 100%;
  box-shadow: 0px -25px 28px -20px#9747FF50;
}

.light-blue-bottom-shadow {
  border-radius: 100%;
  box-shadow: 0px -25px 28px -20px#0D729950;
}

.green-bottom-shadow {
  border-radius: 100%;
  box-shadow: 0px -25px 28px -20px#45D72D50;
}

.yellow-bottom-shadow {
  border-radius: 100%;
  box-shadow: 0px -25px 28px -20px#D1970050;
}

.pink-bottom-shadow {
  border-radius: 100%;
  box-shadow: 0px -25px 28px -20px#DB00FF50;
}
</style>
